import { GoChevronDown } from "react-icons/go";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";

/**
 * Returns the Sort Search component.
 *
 * @returns The Sort Search component.
 */
const SortSearch = ({ sortBy, setSortBy }) => {
    return (
        <>
            <Menu as="div" className="relative inline-block text-left">
                <div>
                    <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                        Sort
                        <GoChevronDown className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                    </Menu.Button>
                </div>

                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-44 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div className="py-1">
                            <Menu.Item>
                                <button
                                    name="alphabetical"
                                    className="w-full"
                                    onClick={() => {
                                        setSortBy("alphabetical")
                                    }}
                                >
                                    {sortBy === "alphabetical" ? (
                                        <p className="text-right mb-0 bg-gray-100 text-gray-900 font-medium block px-4 py-2 text-sm">
                                            Alphabetical
                                        </p>
                                    ) : (
                                        <p className="text-right mb-0 text-gray-700 block px-4 py-2 text-sm">
                                            Alphabetical
                                        </p>
                                    )}
                                </button>
                            </Menu.Item>

                            <Menu.Item>
                                <button
                                    name="role"
                                    className="w-full"
                                    onClick={() => {
                                        setSortBy("role")
                                    }}
                                >
                                    {sortBy === "role" ? (
                                        <p className="text-right mb-0 bg-gray-100 text-gray-900 font-medium block px-4 py-2 text-sm">
                                            Role
                                        </p>
                                    ) : (
                                        <p className="text-right mb-0 text-gray-700 block px-4 py-2 text-sm">
                                            Role
                                        </p>
                                    )}
                                </button>
                            </Menu.Item>
                        </div>
                    </Menu.Items>
                </Transition>
            </Menu>
        </>
    );
};
 
export default SortSearch;